import StackAPI from '@/lib/StackAPI'
import Storage from '@/lib/Storage'
import { captureException } from '@sentry/react'
import { DateTime } from 'luxon'
import { GetListParams } from 'react-admin'

const ENDPOINT = '/partners/earnings/report'

const dateFilter = ({ filter }: GetListParams) => {
  const startDate = filter?.start_date_gte
  const endDate = filter?.start_date_lte
  const earningsDates = filter?.earningsFilter

  if (filter?.sendEmpty) {
    return {
      startDate: null,
      endDate: null
    }
  }

  if (startDate && endDate) {
    return {
      startDate,
      endDate
    }
  }

  if (earningsDates) {
    const [startDate, endDate] = earningsDates.split(',')
    return {
      startDate,
      endDate
    }
  }

  return {
    startDate: startDate || DateTime.now().startOf('month'),
    endDate: endDate || DateTime.now().endOf('month')
  }
}

const getEarnings = async (params: GetListParams) => {
  const { get } = StackAPI()
  const { getActiveRole } = Storage()
  const { pagination, sort } = params
  const context = getActiveRole()?.type?.toLowerCase()
  const { startDate, endDate } = dateFilter(params)
  const request = {
    path: ENDPOINT,
    params: {
      context,
      order: sort,
      page: pagination?.page,
      per_page: pagination?.perPage,
      start_date: startDate,
      end_date: endDate,
      sale_name: params.filter?.saleName
    }
  }

  return await get(request)
    .then(({ data, status }) => (status === 200 ? data : []))
    .catch((error) => {
      captureException(error, { extra: { params } })
      return []
    })
}

export default getEarnings
